import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Portfolio from "@/pages/Portfolio";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <div className="paper-grain" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" richColors />
    </div>
  );
}

export default App;
